import { TranslocoConfig, TranslocoMissingHandler } from '@jsverse/transloco';

export class MissingTranskeyHandler implements TranslocoMissingHandler {
    handle(key: string, config: TranslocoConfig) {
        if (key === undefined || key === null || key == "null") {
            return key;
        }

        key = String(key);

        if (key.startsWith("%t%")) {
            return key.substring(3);
        }
        if (!config.prodMode) {
            console.warn(`Missing translation for key: ${key}`);
        }
        return key;
    }
}